import React, { Component } from "react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PAMonthlyPaymentM from "./PAMonthlyPaymentM";
import PAMonthlyPaymentW from "./PAMonthlyPaymentW";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PAMonthlyPayment extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAMonthlyPayment.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(PAMonthlyPayment.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <PAMonthlyPaymentM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <PAMonthlyPaymentW {...this.props} />,
    });
  }

}

export default PAMonthlyPayment;
